import { render, staticRenderFns } from "./CustomerTabsBar.vue?vue&type=template&id=30c50661"
import script from "./CustomerTabsBar.vue?vue&type=script&lang=js"
export * from "./CustomerTabsBar.vue?vue&type=script&lang=js"
import style0 from "./CustomerTabsBar.vue?vue&type=style&index=0&id=30c50661&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports